@if (config.data && config.data.bannerUrl != undefined) {
  <div class="dashboard-tile">
    @if (config.data.isExternalLink) {
      <a class="tile-link" title="{{config.data.widget_name}}" (click)="openLink(config.data.link)" ></a>
    }
    @if (!config.data.isExternalLink) {
      <a  class="tile-link" (click)="goto(config.data.link)" title="{{config.data.widget_name}}"  ></a>
    }
    <div class="dashboard-body">
      <div class="tile-top-section">
        <img  class="tile-icon"  title="{{config.data.widget_name}}" [attr.src]="config.data.bannerUrl" />
      </div>
      <div class="tile-middle-section">
        @if (config.data.link) {
          {{config.data.widget_name | translate | async}}
        }
        @if (!config.data.link) {
          {{config.data.widget_name | translate | async}}
        }
      </div>
      <div class="title-righticon-section">
        <i aria-hidden="true" class="fa fa-angle-right"></i>
      </div>
    </div>
  </div>
}